import { type ReactNode } from 'react'
import { ButtonGroup } from '@/components/ButtonGroup'
import {
  AutoSkeleton,
  IsSkeletonContext,
  useIsSkeleton,
} from '@/components/Skeleton'
import { Card, CardContent } from '@/components/Card'

export interface ActionCardProps {
  kicker: ReactNode
  title: ReactNode
  children?: ReactNode
  isSkeleton?: boolean
  testId?: string
}

/**
 * A card that prompts the user to take an action.
 */
export function ActionCard({
  kicker,
  title,
  isSkeleton,
  children,
  testId,
}: ActionCardProps) {
  isSkeleton = useIsSkeleton(isSkeleton)

  return (
    <IsSkeletonContext value={isSkeleton}>
      <Card testId={testId}>
        <CardContent>
          <div className="text-body-base mb-sm text-center">
            <AutoSkeleton>{kicker}</AutoSkeleton>
          </div>
          <div className="text-headline-lg text-center">
            <AutoSkeleton>{title}</AutoSkeleton>
          </div>
          {children && (
            <div className="mt-2xl">
              <ButtonGroup stretch stacked>
                {children}
              </ButtonGroup>
            </div>
          )}
        </CardContent>
      </Card>
    </IsSkeletonContext>
  )
}
